export default __webpack_public_path__ + "static/media/center-center.e8858df3.png";